__turbopack_context__.v({
  "active": "StatsCard-module__fqm0JW__active",
  "card": "StatsCard-module__fqm0JW__card",
  "cardHeader": "StatsCard-module__fqm0JW__cardHeader",
  "cardLink": "StatsCard-module__fqm0JW__cardLink",
  "cardTitle": "StatsCard-module__fqm0JW__cardTitle",
  "muted": "StatsCard-module__fqm0JW__muted",
  "pending": "StatsCard-module__fqm0JW__pending",
  "stat": "StatsCard-module__fqm0JW__stat",
  "statLabel": "StatsCard-module__fqm0JW__statLabel",
  "statValue": "StatsCard-module__fqm0JW__statValue",
  "stats": "StatsCard-module__fqm0JW__stats",
});
